<template>
  <md-card>
    <md-card-header>
      <h3>Dirección</h3>
      <slot name="header"></slot>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field
            :class="[
              { 'md-valid': !errors.has('address.state') && touched.state },
              { 'md-form-group': true },
              { 'md-error': errors.has('address.state') },
            ]"
          >
            <md-icon>place</md-icon>
            <label>Estado</label>
            <md-select
              v-model="address.state"
              data-vv-name="address.state"
              name="state"
              required
              v-validate="editValidations.state"
            >
              <md-option
                v-for="state in states"
                :value="state.id"
                :key="state.id"
                >{{ state.name }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('address.state')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('address.state') && touched.state"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field
            :class="[
              {
                'md-valid':
                  !errors.has('address.municipality') && touched.municipality,
              },
              { 'md-form-group': true },
              { 'md-error': errors.has('address.municipality') },
            ]"
          >
            <md-icon>pin_drop</md-icon>
            <label>Municipio</label>
            <md-select
              v-model="address.municipality"
              data-vv-name="address.municipality"
              name="municipality"
              required
              v-validate="editValidations.municipality"
            >
              <md-option
                v-for="municipality in municipalities"
                :value="municipality.id"
                :key="municipality.id"
                >{{ municipality.name }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('address.municipality')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="
                  !errors.has('address.municipality') && touched.municipality
                "
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('address.street') && touched.street },
                { 'md-form-group': true },
                { 'md-error': errors.has('address.street') },
              ]"
            >
              <md-icon>home</md-icon>
              <label>Calle</label>
              <md-input
                v-model="address.street"
                data-vv-name="address.street"
                type="text"
                name="street"
                required
                v-validate="editValidations.street"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('address.street')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('address.street') && touched.street"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>

        <div class="md-layout-item md-size-25 md-xsmall-size-100">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('address.noExt') && touched.noExt },
                { 'md-form-group': true },
                { 'md-error': errors.has('address.noExt') },
              ]"
            >
              <md-icon>home</md-icon>
              <label>Número exterior</label>
              <md-input
                v-model="address.noExt"
                data-vv-name="address.noExt"
                type="text"
                name="noExt"
                required
                v-validate="editValidations.noExt"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('address.noExt')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('address.noExt') && touched.noExt"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>

        <div class="md-layout-item md-size-25 md-xsmall-size-100">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('address.noInt') && touched.noInt },
                { 'md-form-group': true },
                { 'md-error': errors.has('address.noInt') },
              ]"
            >
              <md-icon>location_city</md-icon>
              <label>Número interno</label>
              <md-input
                v-model="address.noInt"
                data-vv-name="address.noInt"
                type="text"
                name="noInt"
                required
                v-validate="editValidations.noInt"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('address.noInt')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('address.noInt') && touched.noInt"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 ml-auto md-xsmall-size-100">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field
              :class="[
                {
                  'md-valid':
                    !errors.has('address.postalCode') && touched.postalCode,
                },
                { 'md-form-group': true },
                { 'md-error': errors.has('address.postalCode') },
              ]"
            >
              <md-icon>public</md-icon>
              <label>C.P.</label>
              <md-input
                v-model="address.postalCode"
                data-vv-name="address.postalCode"
                type="text"
                name="postalCode"
                required
                v-validate="editValidations.postalCode"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('address.postalCode')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="
                    !errors.has('address.postalCode') && touched.postalCode
                  "
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field
            :class="[
              { 'md-valid': !errors.has('address.colony') && touched.colony },
              { 'md-form-group': true },
              { 'md-error': errors.has('address.colony') },
            ]"
          >
            <md-icon>map</md-icon>
            <label>
              <md-progress-spinner
                v-if="loadingColonies"
                :md-diameter="15"
                :md-stroke="3"
                md-mode="indeterminate"
                style="margin: 0"
              >
              </md-progress-spinner>
              Colonia (escriba código postal)
            </label>
            <md-select
              :disabled="!validCP || !crolAddresses.length || loadingColonies"
              v-model="address.colony"
              data-vv-name="address.colony"
              name="colony"
              required
              v-validate="editValidations.colony"
            >
              <md-option
                v-for="item in crolAddresses"
                :value="item.Colonia"
                :key="item.asentamientoId"
                >{{ item.Colonia }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('address.colony')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('address.colony') && touched.state"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { debounce } from "lodash";
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";
import usesParentValidatorMixin from "@/mixins/usesParentValidator";

const modelValidations = {
  state: {
    required: true,
  },
  municipality: {
    required: true,
  },
  street: {
    required: true,
  },
  noInt: {
    required: false,
  },
  noExt: {
    alpha_num: true,
    required: true,
  },
  colony: {
    required: true,
  },
  postalCode: {
    required: true,
    numeric: true,
    min: 5,
    max: 5,
  },
};

const touched = {
  state: false,
  municipality: false,
  street: false,
  noExt: false,
  noInt: false,
  colony: false,
  postalCode: false,
  colony: false,
};

export default {
  name: "ContactAddress",
  mixins: [usesParentValidatorMixin],
  components: { SlideYDownTransition },
  props: {
    address: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    modify: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      crolAddresses: [],
      states: [],
      municipalities: [],
      modelValidations,
      touched,
      loadingColonies: false,
    };
  },
  methods: {
    updateMunicipality() {
      if (!this.address.state) return;
      return catalogService
        .fetch("common/states", this.address.state)
        .then((data) => (this.municipalities = data.Municipality));
    },
  },
  updated() {
    this.$emit("updated", this.address);
  },
  watch: {
    "address.state": function () {
      this.touched.state = true;
      this.address.municipality = null;
      this.updateMunicipality();
    },
    "address.municipality": function () {
      this.touched.municipality = true;
    },
    "address.noInt": function () {
      this.touched.noInt = true;
    },
    "address.noExt": function () {
      this.touched.noExt = true;
    },
    "address.colony": function (v) {
      this.touched.colony = true;
      const found = this.crolAddresses.find((c) => c.Colonia === v);
      if (found) {
        const { asentamientoId } = found;
        this.$emit("setAsentamiento", asentamientoId);
      }
    },
    "address.postalCode": debounce(function (v) {
      this.postalCode = true;
      if (this.validCP) {
        this.loadingColonies = true;
        this.address.colony = null;
        return catalogService
          .fetchColonies(v)
          .then((data) => {
            this.crolAddresses = data;
          })
          .catch(this.$fireErrorResponse)
          .finally(() => (this.loadingColonies = false));
      }
    }, 500),
  },
  computed: {
    editValidations() {
      const { modify } = this;
      if (!modify) {
        return Object.fromEntries(
          Object.entries(modelValidations).map(([field, validations]) => [
            field,
            { ...validations, required: false },
          ])
        );
      } else {
        return modelValidations;
      }
    },
    validCP() {
      const { postalCode } = this.address;
      return postalCode && postalCode.length === 5 && /^\d+$/.test(postalCode);
    },
  },
  mounted() {
    catalogService.fetch("common/states").then((res) => (this.states = res));
    if (this.address.state) {
      this.updateMunicipality().then(() =>
        this.watchTouched({ address: Object.keys(this.modelValidations) })
      );
    } else {
      this.watchTouched({ address: Object.keys(this.modelValidations) });
    }

    if (this.address.postalCode) {
      this.loadingColonies = true;
      catalogService
        .fetchColonies(this.address.postalCode)
        .then((data) => {
          this.crolAddresses = data;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loadingColonies = false));
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Providers/wizard/Address.vue